module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("1iB01"))).then(() => parcelRequire('9Lwss'));